export default __webpack_public_path__ + "static/media/footer-section.dd9b554c.png";